





































/*eslint-disable */
/*
     <button @click="handleContrastClick" class="contrast-switcher">
      <v-icon :class="{'contrast-switcher__icon--active': !!getContrastActive}"
              class="contrast-switcher__icon">mdi-contrast-circle
      </v-icon>
    </button>
    <div class="font-size-switcher">
      <div v-if="getFontSize === 1">
        <button class="font-size-switcher--low" @click="handleFlipResizeClick(2)">
          A-
        </button>
      </div>
      <div v-if="getFontSize === 2">
        <button class="font-size-switcher--standard" @click="handleFlipResizeClick(3)">
          A
        </button>
      </div>
      <div v-if="getFontSize === 3">
        <button class="font-size-switcher--high" @click="handleFlipResizeClick(1)">
          A+
        </button>
      </div>
    </div>
*/

import { computed, defineComponent, Ref } from '@vue/composition-api';

import MapWindow      from '@/components/map/MapWindow.vue';
import TopBar         from '@/components/structural/TopBar.vue';
import SidebarContent from '@/components/structural/SidebarContent.vue';
import FooterContent  from '@/components/structural/FooterContent.vue';
import AppMainLayout  from '@/components/structural/AppMainLayout.vue';
import InfoSidebar    from '@/components/structural/InfoSidebar.vue';
import Modal          from '@/components/modals/Modal.vue';
import store          from './store/index';

const App = defineComponent({
  name: 'App',
  components: {
    MapWindow,
    TopBar,
    SidebarContent,
    FooterContent,
    AppMainLayout,
    InfoSidebar,
    Modal,
  },
  setup() {
    const showModal: Ref<boolean> = computed(() => store.state.modal.display);
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
    const getFontSize: Ref<number> = computed((): number => store.getters.getFlipResizeActive);

    const getFontSizeClass: Ref<string> = computed((): string => {
      let fontClass;

      switch (getFontSize.value) {
        case 1:
          fontClass = 'font-size-low';
          document.documentElement.style.fontSize = '15px';
          break
        case 3:
          fontClass = 'font-size-high';
          document.documentElement.style.fontSize = '17px';
          break
        case 2:
        default:
          fontClass = 'font-size-standard';
          document.documentElement.style.fontSize = '16px';
          break
      }

      return fontClass;
    });

    const handleContrastClick = () => store.commit('flipContrastActive');
    const handleFlipResizeClick = (item: number) => {
      store.commit('flipResizeFont', item);
    };


    return {
      showModal,
      getContrastActive,
      getFontSize,
      getFontSizeClass,
      handleContrastClick,
      handleFlipResizeClick,
    };
  },
  mounted() {
    // Event zamykania modal-u po kliknieciu w overlay
    const overlay = document.querySelector('.overlay');
    if (overlay) {
      overlay.addEventListener('click', () => {
        if (overlay.classList.contains('overlay--show')) {
          store.commit('closeModal');
        }
      });
    }
  },
});

export default App;
